﻿export default class ImageWithlink {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'image-with-link-load':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Beregner teaser modul',
                    'eventAction': 'impression',
                    'eventLabel': 'Beregner teaser modul',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'image-with-link-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Beregner teaser modul',
                    'eventAction': 'click',
                    'eventLabel': this.vm.url,
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
        }

        return trackingObject;
    }
}
